"use strict";
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockLabInfo = void 0;
var code1 = "import React, { useState } from 'react';\n\n" +
    'const ExampleComponent = () => {\n' +
    '  const [count, setCount] = useState(0);\n\n' +
    '  const increment = () => {\n' +
    '    setCount(count + 1);\n' +
    '  };\n\n' +
    '  const decrement = () => {\n' +
    '    if (count > 0) {\n' +
    '      setCount(count - 1);\n' +
    '    }\n' +
    '  };\n\n' +
    '  return (\n' +
    '    <div>\n' +
    '      <p>Count: {count}</p>\n' +
    '      <button onClick={increment}>Increment</button>\n' +
    '      <button onClick={decrement}>Decrement</button>\n' +
    '    </div>\n' +
    '  );\n' +
    '};\n\n' +
    'export default ExampleComponent;\n';
exports.mockLabInfo = {
    success: true,
    info: {
        attemptsPerQuestionAllowed: 3,
        drillTakes: 1,
        name: 'Python Hands-On Labs',
        description: 'SQL injection (SQLi) is a web security vulnerability that allows an attacker to interfere with the queries that an application makes to its database. This can allow an attacker to view data that they are not normally able to retrieve.',
        potentialScore: 24320,
        duration: 6000,
        status: 'not_started',
        questions: [
            {
                uuid: '1',
                vulnerableCode: code1,
                rank: 1,
                displayName: 'Question 1',
                description: 'Description 1',
                cweId: 'CWE-611',
                owaspId: 'A3: Injection',
                sansId: 'SANS-#1',
                helpfulContent: {
                    courses: [
                        {
                            uuid: '1',
                            displayName: 'Course 1',
                            isCompleted: false,
                            url: 'http://example.com/course1',
                        },
                        // ...other courses...
                    ],
                    lessons: [
                        {
                            uuid: '1',
                            displayName: 'Lesson 1',
                            isCompleted: false,
                            url: 'http://example.com/lesson1',
                        },
                        // ...other lessons...
                    ],
                    challenges: [
                        {
                            uuid: '1',
                            displayName: 'Challenge 1',
                            isCompleted: false,
                            url: 'http://example.com/challenge1',
                        },
                        // ...other challenges...
                    ],
                },
                userAnswers: [
                    {
                        result: 20,
                        points: 100,
                        userRemediation: 'Remediation 1',
                    },
                    {
                        result: 100,
                        points: 200,
                        userRemediation: 'Remediation 2222',
                    },
                    // ...other user answers...
                ],
                attemptsLeft: 1,
                language: 'javascript',
            },
            {
                uuid: '2',
                vulnerableCode: 'code2',
                rank: 2,
                displayName: 'Question 2',
                description: 'Description 2',
                cweId: 'CWE-77',
                owaspId: 'A5: Security Misconfiguration ',
                sansId: 'SANS-#4',
                helpfulContent: {
                    courses: [
                        {
                            uuid: '2',
                            displayName: 'Course 2',
                            isCompleted: true,
                            url: 'http://example.com/course2',
                        },
                        // ...other courses...
                    ],
                    lessons: [
                        {
                            uuid: '2',
                            displayName: 'Lesson 2',
                            isCompleted: false,
                            url: 'http://example.com/lesson2',
                        },
                        // ...other lessons...
                    ],
                    challenges: [
                        {
                            uuid: '2',
                            displayName: 'Challenge 2',
                            isCompleted: false,
                            url: 'http://example.com/challenge2',
                        },
                        // ...other challenges...
                    ],
                },
                userAnswers: [
                    {
                        result: 70,
                        points: 200,
                        userRemediation: 'Remediation 2',
                    },
                    // ...other user answers...
                ],
                attemptsLeft: 0,
                language: 'javascript',
            },
            {
                uuid: '3',
                vulnerableCode: 'code3',
                rank: 3,
                displayName: 'Question 3',
                description: 'Description 3',
                cweId: 'CWE-78',
                owaspId: 'A7: Identification and Authentication Failures ',
                sansId: 'SANS-#13',
                helpfulContent: {
                    courses: [
                        {
                            uuid: '3',
                            displayName: 'Course 3',
                            isCompleted: true,
                            url: 'http://example.com/course3',
                        },
                        // ...other courses...
                    ],
                    lessons: [
                        {
                            uuid: '3',
                            displayName: 'Lesson 3',
                            isCompleted: true,
                            url: 'http://example.com/lesson3',
                        },
                        // ...other lessons...
                    ],
                    challenges: [
                        {
                            uuid: '3',
                            displayName: 'Challenge 3',
                            isCompleted: false,
                            url: 'http://example.com/challenge3',
                        },
                        // ...other challenges...
                    ],
                },
                userAnswers: [
                // ...other user answers...
                ],
                attemptsLeft: 3,
                language: 'javascript',
            },
        ],
    },
};
